<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Newsletter</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link> /
      <b>Marketing</b> /
      <b>Newsletter</b>
    </div>

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-4">
      
      <div class="col-md-12 mb-4">
        <div class="card text-left">

          <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li class="nav-item">
              <a
                class="nav-link active"
                id="home-basic-tab"
                data-toggle="tab"
                href="#_active"
                role="tab"
                aria-controls="_active"
                aria-selected="true"
                >Active</a
              >
            </li>
            <li class="nav-item">
              <a
                class="nav-link"
                id="profile-basic-tab"
                data-toggle="tab"
                href="#_inactive"
                role="tab"
                aria-controls="_inactive"
                aria-selected="false"
                >Inactive</a
              >
            </li>
          </ul>

          <div class="tab-content" id="myTabContent">
            <div
              class="tab-pane fade show active bg-white"
              id="_active"
              role="tabpanel"
              aria-labelledby="individual-tab"
            >
              <div class="card-body">
              
                <div class="input-group mb-4 d-flex flex-row justify-content-between p2">
                  <h4 class="card-title mb-0">Newsletter</h4>
                  <router-link :to="{ name: 'add-newsletter' }" type="button" class="btn btn-primary mr-4">Add New</router-link>
                </div>
                <div>
                  <small class="text-danger ml-4">Please drag and drop to rearrange the newsletters.</small>
                </div>
                <div v-show="active_newsletters.length < 1">No Active Newsletter(s)</div>
                <div
                  class="px-4" 
                  v-for="(newsletter, index) in active_newsletters"
                  :key="newsletter.id"
                  :draggable="true"
                  @dragstart="onDragStart(index, $event)"
                  @dragover="onDragOver($event)"
                  @drop="onDrop(index, $event)"
                  @dragend="onDragEnd"
                >
                  <newsletter-list :newsletter="newsletter" :fetchDatas="fetchDatas" />
                </div>
              
              </div>
            </div>

            <div
              class="tab-pane fade bg-white"
              id="_inactive"
              role="tabpanel"
              aria-labelledby="multiple-tab"
            >
            <div class="card-body">
                <div class="input-group mb-4 d-flex flex-row justify-content-between p2">
                  <h4 class="card-title mb-0">Inactive Newsletter</h4>
                </div>
                <div v-show="inactive_newsletters.length < 1">No Inactive Newsletter(s)</div>
                <div
                  class="px-4" 
                  v-for="(newsletter, index) in inactive_newsletters"
                  :key="newsletter.id"
                >
                  <newsletter-list :newsletter="newsletter" :fetchDatas="fetchDatas" />
                </div>
              </div>
            </div>
          </div>

          
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import NewsletterList from "./list.vue";
import { getNewsletter, updateNewsletterArrangement } from "../../../services/NewsletterService";
export default {
  components: { NewsletterList },

  data() {
    return {
      active_newsletters: [],
      inactive_newsletters: [],
    }
  },

  methods: {
    async fetchDatas() {
      try {
        const response = await getNewsletter();
        this.active_newsletters = response.data.data.active;
        this.inactive_newsletters = response.data.data.inactive;

      } catch (err) {
        console.error(err);
      }
    },

    async updateArrangement(data) {
      try {
        const response = await updateNewsletterArrangement(data);
      } catch (err) {
        console.error(err)
      }
    },

    onDragStart(index, event) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', index);
      this.draggedIndex = index;
    },

    onDragOver(event) {
      event.preventDefault();
    },
    
    onDrop(index, event) {
      event.preventDefault();
      const draggedIndex = this.draggedIndex;
      const draggedItem = this.active_newsletters[draggedIndex];
      this.active_newsletters.splice(draggedIndex, 1);
      this.active_newsletters.splice(index, 0, draggedItem);
    },

    async onDragEnd(event) {
      // Run your function here
      event.preventDefault();
      let position = this.active_newsletters.map(item => item.id)
      
      await this.updateArrangement({position: position});
    },

    goTo(id) {
      return `/marketing/newsletter/edit/${id}`;
    },
  },

  async mounted() {
    await this.fetchDatas();
  },
}

</script>

<style>
.ellipsis-container {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 4;
}

.ellipsis-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 4;
}
</style>
